import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";

export type AvatarStore = {
  avatars: Record<string, string>; // login -> url/base64
  setAvatar: (login: string, url: string) => void;
  clearAvatars: () => void;
};

export const useAvatarStore = create<AvatarStore>()(
  devtools(
    persist(
      (set) => ({
        avatars: {},
        setAvatar: (login: string, url: string) =>
          set((state) => ({
            avatars: { ...state.avatars, [login]: url },
          })),
        clearAvatars: () => set({ avatars: {} }),
      }),
      { name: "avatar-store" }
    ),
    { name: "avatar-store" }
  )
);

/**
 * Hook local first para buscar o avatar de um usuário.
 * Sempre retorna a URL local se existir, senão undefined.
 */
export function useLocalAvatar(login: string): string | undefined {
  return useAvatarStore((s) => s.avatars[login]);
}
